import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { SocialMediaFileTypes } from '../api/models';

@Directive({
  selector: '[mediaFileTypeStyle]',
  standalone: true,
})
export class MediaFileTypeDirective implements OnInit {
  @Input('mediaFileTypeStyle') socialMediaFileType: SocialMediaFileTypes;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi ';

    switch (this.socialMediaFileType) {
      case SocialMediaFileTypes.Audio:
        classList += 'mdi-volume-high text-warning mdi-30px';
        break;
      case SocialMediaFileTypes.Image:
        classList += 'mdi-image text-info mdi-30px';
        break;
      case SocialMediaFileTypes.Pdf:
        classList += 'mdi-file-pdf-box mdi-30px text-danger';
        break;
      case SocialMediaFileTypes.Video:
        classList += 'mdi-video mdi-30px text-primary';
        break;

      default:
        break;
    }

    return classList;
  }
}
